import { render, staticRenderFns } from "./PerfilEditar.vue?vue&type=template&id=12b5a324&"
import script from "./PerfilEditar.vue?vue&type=script&lang=js&"
export * from "./PerfilEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports